// removed by extract-text-webpack-plugin
module.exports = {"link":"style__link___1ta2V"};


//////////////////
// WEBPACK FOOTER
// ./components/Breadcrumbs/style.scss
// module id = ./components/Breadcrumbs/style.scss
// module chunks = 5